import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/ContactFormWidget/ContactFormWidget.jsx");
;
import(/* webpackMode: "eager" */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/FixedButton/FixedButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/SEO/FBPixels/FBPixels.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/SEO/GTag/Gtag.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/VoiceAgentButton/VoiceAgentButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/components/WhatsAppButton/WhatsAppButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/layouts/LayoutsWrapper/LayoutsWrapper.jsx");
;
import(/* webpackMode: "eager" */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/node_modules/next/dist/client/script.js");
